import React, { useEffect } from "react";

import {
  pricingTableIdProvider,
  pricingTableIdClient,
  pricingTableIdStartup,
  stripePublishableKey,
} from '../../../stripe-config';

const StripePricingTable = ({ userEmail, isClient, isStartup }) => {
  useEffect(() => {
    let script = null;

    if (window) {
      script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      if (window && script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return React.createElement("stripe-pricing-table", {
    "pricing-table-id": isClient ? pricingTableIdClient : isStartup ? pricingTableIdStartup : pricingTableIdProvider,
    "publishable-key": stripePublishableKey,
    "customer-email": userEmail,
  });
};

export default StripePricingTable;
